export type SyncDocumentIdentity = {
  clinicId: number;
  encounterId: string;
};

export const buildSyncDocumentName = ({ clinicId, encounterId }: SyncDocumentIdentity): string => {
  if (!Number.isInteger(clinicId) || clinicId <= 0 || !encounterId) {
    throw new Error('Invalid sync document identity');
  }

  return `clinic-${clinicId}:encounter-${encounterId}`;
};

export const parseSyncDocumentName = (documentName: string): SyncDocumentIdentity | null => {
  const match = /^clinic-([1-9]\d*):encounter-(.+)$/.exec(documentName);

  if (!match) return null;

  const clinicId = Number(match[1]);

  if (!Number.isSafeInteger(clinicId)) return null;

  return { clinicId, encounterId: match[2] };
};

export const parseLegacySyncDocumentName = (documentName: string): string | null => {
  const match = /^encounter-(.+)$/.exec(documentName);

  return match?.[1] || null;
};
